import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ variables, breakpoints }) => ({
  cookieStatementContainer: {
    padding: '32px',
    fontSize: '16px',
    lineHeight: '1.4',
    [breakpoints.down('xs')]: {
      padding: variables?.spacingE
    },
    '& table': {
      border: `1px solid #333`,
      '& td,th': {
        padding: variables?.spacingB,
        border: `1px solid #333`
      }
    },
    '& a': {
      fontWeight: 'bold',
      textDecoration: 'underline'
    }
  }
}));

export default styles;
